import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import infoImg from 'src/assets/icons/info.svg';
import { media } from 'src/common/styles/breakpoints';

const InfoIcon = styled.img<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'none' : 'block')};
  align-self: flex-end;
  pointer-events: all;

  &:hover {
    cursor: pointer;
  }
`;

const InfoWrapper = styled.div<{ open: boolean }>`
  position: absolute;
  overflow: hidden;
  width: 24px;
  height: 24px;
  top: 4px;
  right: 4px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #eef0f1;
  transition: all 0.4s ease-in-out;

  p {
    opacity: 0;
    visibility: hidden;
    max-width: 275px;
    margin-top: 16px;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: ${({ theme }) => theme.text.primary};
    transition: all 0.4s;

    ${media.w.min.px576(css`
      margin-top: 4px;
      font-size: 12px;
    `)}
  }

  ${({ open }) =>
    open &&
    css`
      width: calc(100% - 8px);
      height: calc(100% - 8px);

      ${media.w.min.px576(css`
        width: calc(100% - 16px);
        height: calc(100% - 16px);
        top: 8px;
        right: 8px;
      `)};

      p {
        opacity: 0.67;
        visibility: visible;
      }
    `}
`;

export const AspspInfoToolTip = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLImageElement>) => {
    e.stopPropagation();
    setIsOpen((p) => !p);
  };

  return (
    <InfoWrapper open={isOpen}>
      <InfoIcon onClick={(e) => handleClick(e)} src={infoImg} isOpen={isOpen} />
      <p>
        Przepraszamy, obecnie ten bank jest niedostępy, spróbuj wybrać inny
        bank.
      </p>
    </InfoWrapper>
  );
};
